<form [formGroup]="dynamicForm" 
      (change)="onFormChange()" 
      class="form custom-form kt-form" 
      [class.no-button]="(!getHasCreate() && !getHasBinding() && !getHasUpdate() && !getHasDelete() && !getCleanFormButton()) || getDisabledBtns()"
      [ngClass]="getStyleClass()" 
      [ngStyle]="{'text-align': this.getFormAlignment()}"
      (keydown.enter)="$event.preventDefault()">

  <ng-container #target></ng-container>

  <div class="kt-portlet__foot" [hidden]="getDisabledBtns() || (!getHasCreate() && !getHasUpdate() && !getHasDelete())">
    <div class="col btns-col" [hidden]="!(getHasCreate() && !getHasBinding())">
      <ng-container #saveBtn></ng-container>
    </div>
    <div class="col btns-col" [hidden]="!(getHasUpdate() && getHasBinding())">
      <ng-container #updateBtn></ng-container>
    </div>
    <div class="col btns-col" [hidden]="!getHasCreate()">
      <ng-container #cancelBtn></ng-container>
    </div>
    <div class="col btns-col pull-right" [hidden]="!(getHasDelete() && getHasBinding())">
      <ng-container #delBtn></ng-container>
    </div>
  </div>
</form>